
// import translate from 'core/translate'
import useInitialState from './useInitialState'

export default function useResource(key, ...args) {
    const resources = useInitialState(state => state.resources); 

    // the key exists
    if (resources === undefined || resources[key.toLowerCase()] === undefined)
        return key.toLowerCase()

    // return entered resource in lowercase if exists
    const formatString = resources[key.toLowerCase()]

    // return key as entered
    if (!formatString) return key

    // adds resource parameters
    const t = formatString.replace(/{(\d+)}/g, (match, number) => typeof args[number] != 'undefined' ? args[number] : match)

    return t
}